module.exports = __webpack_public_path__ + "static/NF_CS_C-b8b4d1c277a1209ffe5bc78b127d3512.png";